import React, { useEffect } from "react";
import "./Home.css";
import academyBuilding from "../assets/images/mosque.jpg";
import lib from "../assets/images/lib2.webp";
import { FaGraduationCap, FaBookOpen, FaUsers, FaAward, FaHeart, FaLightbulb } from 'react-icons/fa';

import Header from "../component/Header/Header";
import Message from "../component/Message/Message";
import Admission from "../component/Admissions/Admission";
import { Link } from "react-router-dom";
import Academics from "../component/Academics/Academics";
import Faculties from "../component/Faculties/Faculties";
import Facilities from "../component/Facilities/Facilities";
import NewsModal from "../component/NewsModal/NewsModal";
import NewsSection from "../component/NewsSection/NewsSection";
import AnnouncementModal from "../component/AnnouncementModal/AnnouncementModal";

const Home = () => {
  useEffect(() => {
    const links = document.querySelectorAll(".nav-links a");
    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const targetId = link.getAttribute("href").replace("#", "");
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 80,
            behavior: "smooth",
          });
        }
      });
    });
  }, []);

  return (
    <>
      {/* 🔹 Header */}
      <Header />
      {/* <NewsModal /> */}
      <AnnouncementModal/>
      {/* 🔹 Hero Section */}
      <section className="hero-section" id="home">
        <div className="overlay">
         <h1>Explore Alasar Academy</h1>
         <p>Empowering Knowledge & Excellence</p>
        </div>
      </section>

      {/* 🔹 About Section (Modern Layout like Bahria University) */}
      <section className="about-section" id="about">
        <div className="about-container">
          {/* Left Side - Image */}
          <div className="about-image">
            <img src={academyBuilding} alt="Alasar Academy" />
          </div>

          {/* Right Side - Text */}
          <div className="about-text">
            <h3>WELCOME TO</h3>
            <h1>ALASAR ACADEMY USTERZAI PAYAN</h1>
            <p>
              Alasar Academy is a dedicated educational institution located in
              Usterzai Payan, Kohat. We focus on providing quality education,
              discipline, and an inspiring learning environment to help students
              achieve academic excellence and personal growth.
            </p>
            <Link to="/about"  className="learn-more">
              LEARN MORE
            </Link>
          </div>
        </div>
      </section>
      <section>
        <Message />
      </section>

      {/* 🔹 Academics Section */}
      <section className="academics-section" id="academics">
        <Academics />
      </section>

      {/* 🔹 Department Section */}
      {/* <section className="department-section" id="department">
        <h2>Departments</h2>
        <p>
          We offer a wide range of departments focused on Science, Arts,
          Computer Studies, and more — each designed to nurture excellence.
        </p>
      </section> */}

      {/* 🔹 Faculties Section */}
      {/* <section className="faculties-section" id="faculties">
        <Faculties />
      </section> */}

      {/* 🔹 Other Components */}
      
      <section id="admissions">
            <Admission />
      </section>
        <section id="facilities">
            <Facilities />
      </section>

      {/* 🔹 News Section */}
      <NewsSection />
  
      {/* 🔹 Commitment Section */}
      <section className="commitment-section" id="commitment">
        <div className="container">
          <div className="commitment-content">
            <h2>Our Commitment</h2>
            <p>
              Inspiring excellence, strengthening faith, and building the leaders of
              tomorrow — Alasar Academy continues to shape a brighter future for our
              community and the Ummah.
            </p>
            <div className="commitment-features">
              <div className="commitment-item">
                <h4>Quality Education</h4>
                <p>Comprehensive curriculum designed for holistic development</p>
              </div>
              <div className="commitment-item">
                <h4>Islamic Values</h4>
                <p>Integrating Islamic principles into every aspect of learning</p>
              </div>
              <div className="commitment-item">
                <h4>Character Building</h4>
                <p>Developing moral character and ethical leadership skills</p>
              </div>
            </div>
          </div>
        </div>
      </section>
  
    </>
  );
};

export default Home;
